import { useCallback, useState } from "react";
import SiteLayout from "@/components/feature/SiteLayout";
import PriceTicker from "@/components/feature/PriceTicker";
import Toast from "@/components/base/Toast";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import type { Software } from "@/utils/software";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedCarousel from "./components/FeaturedCarousel";
import HomeSidebar from "./components/HomeSidebar";
import LatestSection from "./components/LatestSection";
import HotSection from "./components/HotSection";
import CommitmentSection from "./components/CommitmentSection";

export default function Home() {
  const [toast, setToast] = useState<string | null>(null);

  useDocumentMeta({
    title: "黄金网站软件app免费 - 实用黄金投资软件推荐与下载",
    description:
      "黄金网站软件app免费提供多款实用的黄金投资软件和应用，涵盖市场行情分析、价格走势及理财工具，帮助用户轻松掌握黄金资讯与投资技巧。",
    keywords:
      "黄金网站软件app免费,黄金投资软件,黄金行情app,黄金价格走势,黄金理财工具,投资软件免费下载",
  });

  const handleDownload = useCallback((item: Software) => {
    setToast(`已打开「${item.name}」的示范下载链接（演示功能，无真实下载）`);
  }, []);

  const closeToast = useCallback(() => setToast(null), []);

  return (
    <SiteLayout>
      <HeroSection />
      <PriceTicker />
      <CategoryGrid />

      <div className="container-page py-10">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-start">
          <div className="order-2 w-full lg:order-1 lg:w-72 lg:shrink-0">
            <HomeSidebar />
          </div>
          <div className="order-1 flex min-w-0 flex-1 flex-col gap-8 lg:order-2">
            <FeaturedCarousel onDownload={handleDownload} />
            <LatestSection onDownload={handleDownload} />
            <HotSection onDownload={handleDownload} />
          </div>
        </div>
      </div>

      <CommitmentSection />
      <Toast message={toast} onClose={closeToast} />
    </SiteLayout>
  );
}